import React, {useEffect, useRef} from 'react'
import './Runner.css';

const Runner = () => {
  const textRun = useRef();

  const textScrolling = () => {
    if (textRun.current) {
      const scrollY = window.scrollY || window.pageYOffset;
      textRun.current.style.setProperty("--scroll", scrollY);
    }
  };

  useEffect(() => {
    const smoothScroll = () => {
      textScrolling();
      requestAnimationFrame(smoothScroll);
    };

    window.addEventListener("scroll", textScrolling);
    smoothScroll(); // Memanggil fungsi smoothScroll untuk pertama kali

    return () => {
      window.removeEventListener("scroll", textScrolling);
    };
  }, []);
  return (
    <>
      <section className='running-text w-full overflow-hidden mt-10'>
        <p
          className='text-runing lg:text-9xl md:text-9xl  sm:text-5xl overflow-hidden w-max'
          ref={textRun}
        >
          "Teknologi Ramah Lingkungan, Lingkungan yang Terpelihara: Bersama Kita
          Menciptakan Perubahan, Serta Pencapaian pada level yang tertinggi."
        </p>
      </section>
    </>
  );
};

export default Runner;
